import { useEffect, useState } from "react"

import { Form, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"

import Icon from "../../Icon"
import utils from "../../Utils/utils"
import ButtonComponent from "../Button"
import InputComponent from "../Input"

const { Link } = Typography

function RestorePasswordForm({ error, ...props }) {
  const [errorText, setErrorText] = useState(null)
  const [errorLink, setErrorLink] = useState(null)
  const [, forceUpdate] = useState({}) // To disable submit button at the beginning.
  const [isDisabled, setIsDisabled] = useState(true)

  const [form] = Form.useForm()
  const { t } = useTranslation()

  useEffect(() => {
    forceUpdate({})
  }, [])

  useEffect(() => {
    if (error) {
      if (typeof error === "string") {
        setErrorText(error)
      } else {
        setErrorText(error?.detail)
        setErrorLink(error?.link || null)
      }
    }
  }, [error])

  const onFinish = (values) => {
    props.onSubmit(values)
  }

  const onFinishFailed = ({ errorFields }) => {
    if (errorFields) setErrorText(errorFields[0]["errors"])
  }

  function handleClearError(e, field) {
    form.setFields([
      {
        name: field,
        errors: []
      }
    ])
    setErrorText(null)
    setErrorLink(null)
  }

  function handleChange(e) {
    const { name, value } = e.target

    handleClearError(e, name)

    if (utils.validateEmail(value)) {
      if (isDisabled) setIsDisabled(false)
    } else {
      setIsDisabled(true)
    }
  }

  return (
    <Form
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      className="login-form restore"
      layout="vertical"
    >
      <Form.Item noStyle shouldUpdate={true}>
        {() => (
          <div className={cls("error-text", { "error-text_empty": !errorText })}>
            {errorText && <Icon type={"alert_triangle_error"} role={"icon"} />}
            {errorText}
            {errorLink && errorText && (
              <Link
                href={errorLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: "12px" }}
              >
                {" " + errorLink}
              </Link>
            )}
          </div>
        )}
      </Form.Item>

      <Form.Item
        name="email"
        validateStatus={errorText ? "error" : null}
        rules={[{ type: "email", message: t("The email you entered is incorrect") }]}
        style={{ marginBottom: 0 }}
      >
        <InputComponent
          placeholder={t("Email address")}
          name="email"
          type="email"
          onChange={(e) => handleChange(e)}
        />
      </Form.Item>

      <ButtonComponent
        type="primary"
        htmlType="submit"
        size="large"
        block
        disabled={isDisabled || !form.getFieldValue("email")}
      >
        {t("Send reset link")}
      </ButtonComponent>

      {props.children}
    </Form>
  )
}

export default RestorePasswordForm
